import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Instagram, Facebook } from "lucide-react";
import { Logo } from "./Logo";
import { useI18n } from "../i18n";
import * as apiClient from "../api";

export const Footer = () => {
  const { t } = useI18n();
  const { data: settings } = useQuery({ queryKey: ["publicSettings"], queryFn: apiClient.getPublicSettings });
  const email = settings?.email || "info@cristaldaexperience.it";
  const socials = [
    settings?.instagram && { icon: Instagram, url: settings.instagram, label: "Instagram" },
    settings?.facebook && { icon: Facebook, url: settings.facebook, label: "Facebook" },
    settings?.tiktok && { icon: null, url: settings.tiktok, label: "TikTok" },
  ].filter(Boolean);

  return (
    <footer className="bg-[#0A1128] text-white mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Logo light />
          <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">Esperienze da vivere, non semplicemente posti da vedere.</p>
          <p className="mt-4 font-accent italic text-secondary text-lg">Dal mare alle montagne.</p>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">Scopri</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/esperienze" className="hover:text-secondary transition-colors">Esperienze</Link></li>
            <li><Link to="/esperienze" className="hover:text-secondary transition-colors">Categorie</Link></li>
            <li><Link to="/domani" className="hover:text-secondary transition-colors">{t("nav.tomorrow")}</Link></li>
            <li><Link to="/last-minute" className="hover:text-secondary transition-colors">{t("nav.lastminute")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">Cristalda</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/partner" className="hover:text-secondary transition-colors">Diventa partner</Link></li>
            <li><Link to="/concierge" className="hover:text-secondary transition-colors">{t("nav.concierge")}</Link></li>
            <li><Link to="/guide" className="hover:text-secondary transition-colors">{t("footer.guidesblog")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/50 mb-4">Supporto</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><a href={`mailto:${email}`} className="hover:text-secondary transition-colors">Contatti</a></li>
            <li><Link to="/legale/termini" className="hover:text-secondary transition-colors">{t("footer.terms")}</Link></li>
            <li><Link to="/legale/privacy" className="hover:text-secondary transition-colors">Privacy Policy</Link></li>
            <li><Link to="/legale/cookie" className="hover:text-secondary transition-colors">Cookie Policy</Link></li>
          </ul>
          {socials.length > 0 && (
            <div className="flex items-center gap-3 mt-5">
              {socials.map((s) => (
                <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.label}
                   className="h-9 w-9 rounded-full bg-white/10 hover:bg-secondary hover:text-primary flex items-center justify-center transition-colors">
                  {s.icon ? <s.icon className="h-4 w-4" /> : <span className="text-[10px] font-bold">TT</span>}
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Cristalda Experience — Gargano, Italia</span>
          <span>Un marchio gestito da Michelangela Trimigno &amp; C. S.a.s.</span>
        </div>
      </div>
    </footer>
  );
};
